import { setDoc } from 'firebase/firestore/lite'
import refs from '../refsLite'

export async function saveAssignment(assignment) {
  assignment.updated = +new Date()
  await setDoc(refs.assignment(assignment.id), assignment)
}
